// PRODUCT
import * as resultsActions from './product/resultsActions';
import * as reviewActions from './product/reviewActions';
import * as newActions from './product/searches/newActions';
import * as listActions from './product/searches/listActions';
import * as dashboardActions from './product/searches/dashboardActions';
import * as settingsActions from './product/settingsActions';
import * as embedActions from './product/embedActions';
import * as analyticsActions from './product/analyticsActions';
import * as resultsMonetizationActions from './product/resultsMonetizationActions';
// FINGERPRINTING
import * as fingerprintingActions from './product/fingerprintingActions';
// CONTENT ID
import * as creatorReferralActions from './product/creatorReferralActions';
import * as contentIdAssetsActions from './product/contentId/assetsActions';
import * as contentIdClaimsActions from './product/contentId/claimsActions';
import * as contentIdManualClaimActions from './product/contentId/manualClaimActions';
import * as contentIdClaimReleaseActions from './product/contentId/claimReleaseActions';
import * as contentIdAllowlistActions from './product/contentId/allowlistActions';
// CYCLOPS
import * as organizationsActions from './cyclops/organizationsActions';
import * as livestreamsActions from './cyclops/livestreamsActions';
import * as piracystreamsActions from './cyclops/piracystreamsActions';
import * as cyclopsAnalyticsActions from './cyclops/analyticsActions';
// ADMIN
import * as adminAuthActions from './admin/authActions';
import * as adminFileImportsActions from './admin/fileImportsActions';
import * as adminCompanyActions from './admin/companyActions';
import * as adminSearchActions from './admin/searchActions';
import * as adminManualClaimActions from './admin/manualClaimActions';
import * as adminMonetizationRequestActions from './admin/monetizationRequestActions';
import * as adminPayoutActions from './admin/payoutActions';
import * as adminCidPayoutStatusActions from './admin/cidPayoutStatusActions';
import * as adminCidAnalyticsActions from './admin/cidAnalyticsActions';
import * as adminYtAuditsActions from './admin/adminYtAuditsActions';
import * as adminCustomOnboardingActions from './admin/customOnboardingActions';
import * as adminOnboardingActions from './admin/onboardingActions';
import * as adminNagraMonitoringActions from './admin/nagra/nagraMonitoringActions';
import * as adminNagraCandidatesActions from './admin/nagra/nagraCandidatesActions';
import * as demoActions from './product/demoActions';
// OTHER
import * as authActions from './product/authActions';
import * as paymentActions from './paymentActions';
import * as redirectActions from './redirectActions';
import * as faviconActions from './faviconActions';
import * as noticeActions from './noticeActions';
import * as aborterHelper from './aborterHelper';
import * as appConfigActions from './appConfigActions';


// ~~~ PRODUCT/BLACKLIGHT ACTIONS ~~~
// Results
export const {
  initiateResultsUploadConfigRequest,
  clearResultsUploadConfigRequest,
  submitResultsFileUploadRequest,
  submitProductResultsImportRequest,
  submitProductSingleResultImportRequest,
  initiateResultsInfringementsRequest,
  clearResultsInfringementsRequest,
  initiateResultsInfringementsMetaRequest,
  clearResultsInfringementsMetaRequest,
  initiateResultsRemovalsRequest,
  clearResultsRemovalsRequest,
  initiateResultDetailRequest,
  clearResultDetailRequest,
} = resultsActions;

// Review
export const {
  initiateProductReviewRequest,
  clearProductReviewRequest,
  updateProductReviewSelectionsRequest,
  initiateProductReviewStatsRequest,
  clearProductReviewStatsRequest,
  initiateProductReviewMetaRequest,
  clearProductReviewMetaRequest,
  bulkUpdateReviewStatusByDomainRequest,
} = reviewActions;

export const {
  initiateResultsMonetizationRequest,
} = resultsMonetizationActions;

// Searches - New
export const {
  initiateNewFormConfigRequest,
  clearNewFormConfigRequest,
  submitNewSearchRequest,
  initiateNewBulkFormConfigRequest,
  clearNewBulkFormConfigRequest,
  submitNewBulkSearchRequest,
  submitSearchFeatureRequest,
  initiateNewSearchesTeamsRequest,
  clearNewSearchesTeamsRequest,
  updateNewSearchesTeamsRequest,
} = newActions;

// Searches - List
export const {
  initiateProductListSearchesRequest,
  clearProductListSearchesRequest,
  initiateProductListSearchesAddedRequest,
  clearProductListSearchesAddedRequest,
  initiateProductListSearchesMetaRequest,
  clearProductListSearchesMetaRequest,
  initiateProductListSearchesStatsRequest,
  clearProductListSearchesStatsRequest,
} = listActions;

// Searches - Dashboard
export const {
  initiateProductDashboardSearchResultsRequest,
  clearProductDashboardSearchResultsRequest,
  clearProductDashboardSearchResultsMetaRequest,
  initiateProductDashboardSearchResultsMetaRequest,
} = dashboardActions;

// Settings
export const {
  initiateCompanySettingsRequest,
  clearCompanySettingsRequest,
  initiateSingleCompanySettingRequest,
  clearSingleCompanySettingRequest,
  updateCompanyDomainRequest,
  initiateCompanyNotificationSettingRequest,
  clearCompanyNotificationSettingRequest,
  updateCompanyNotificationSettingRequest,
  initiateCompanyMaintenanceSettingsRequest,
  clearCompanyMaintenanceSettingsRequest,
  initiateCompanyUnitsRequest,
  clearCompanyUnitsRequest,
  updateCompanyUnitsRequest,
} = settingsActions;

// Embed
export const {
  refreshEmbedAccessDataRequest,
  clearEmbedAccessDataRequest,
  refreshReportAccessDataRequest,
  clearReportAccessDataRequest,
} = embedActions;

// ~~~ ADMIN ACTIONS ~~~
// Auth
export const {
  adminLogInRequest,
  adminLogOutRequest,
  adminRefreshRequest,
} = adminAuthActions;

// File Imports
export const {
  submitSetReviewStatusImportRequest,
  clearFileImportResultRequest,
  submitDmcaTakedownNoticesImportRequest,
  submitDmcaEscalationImportRequest,
  submitCloudflareAdhocImportRequest,
  submitDmcaRetractionNoticesImportRequest,
  submitResultsImportRequest,
  submitMarkUrlsDownImportRequest,
  submitTakedownStatsImportRequest,
  submitCreateBulkSearchesImportRequest,
  submitMarkHostsDownImportRequest,
  submitDowncheckUrlsImportRequest,
  clearFileImportsRequest,
  initiateFileImportsRequest,
} = adminFileImportsActions;

// Companies
export const {
  fetchCompanyListRequest,
  clearCompanyListRequest,
} = adminCompanyActions;

// Searches and Search Types
export const {
  fetchAdminSearchTypesRequest,
  clearAdminSearchTypesRequest,
  fetchCompanyFormFieldsRequest,
  clearCompanyFormFieldsRequest,
} = adminSearchActions;

// Manual claim requests (admin / QA)
export const {
  initiateAdminFetchManualClaimRequests,
  initiateAdminFetchManualClaimRequest,
  initiateAdminUpdateManualClaimRequest,
} = adminManualClaimActions;

// Admin Monetization Requests
export const {
  initiateFetchMonetizationRequests,
  clearMonetizationRequests,
  initiateFetchMonetizationRequestDetails,
  clearMonetizationRequestDetails,
  initiateUpdateMonetizationRequest,
} = adminMonetizationRequestActions;

// Admin Payouts
export const {
  initiateFetchPayouts,
  clearPayouts,
  initiateUpdatePayout,
  initiateTriggerPayout,
  initiateFetchPayoutHistory,
} = adminPayoutActions;

// Admin CID Payout Setup Status
export const {
  initiateFetchCidPayoutSetupStatus,
  clearCidPayoutSetupStatus,
} = adminCidPayoutStatusActions;

// Admin CID Analytics Dashboard
export const {
  initiateFetchCidAnalytics,
  initiateFetchCidAnalyticsFilterOptions,
  initiateFetchYtAudits,
  clearCidAnalytics,
} = adminCidAnalyticsActions;

// Admin YT Audits
export const {
  fetchAdminYtAudits,
  fetchAdminYtAuditDetail,
  fetchAdminYtAuditUsers,
  batchCreateAdminAudits,
  removeAdminYtAuditChannel,
  adminYtAuditDetailClear,
  adminYtAuditsClear,
} = adminYtAuditsActions;

// Admin Custom Onboarding (Prefill Link Generator)
export const {
  fetchAdminPrefillPricingRequest,
  clearAdminPrefillPricingRequest,
  initiateCreatePrefillOnboardingRequest,
  clearAdminPrefillOnboardingRequest,
} = adminCustomOnboardingActions;

// Admin Onboardings Tracker
export const {
  initiateFetchAdminOnboardings,
  clearAdminOnboardings,
  initiateFetchAdminOnboardingDetails,
  clearAdminOnboardingDetails,
} = adminOnboardingActions;

// Admin Nagra Monitoring Operations
export const {
  fetchNagraMonitoringOperations,
  createNagraMonitoringOperation,
  endNagraMonitoringOperation,
} = adminNagraMonitoringActions;

// Admin Nagra Candidates
export const {
  fetchNagraCandidates,
  fetchNagraBatch,
  approveAndSubmitNagraBatchCandidate,
  rejectNagraBatchCandidate,
  fetchNagraCandidate,
  updateNagraCandidate,
  updateNagraCandidateStatus,
  uploadNagraScreenshot,
  submitNagraCandidate,
  fetchNagraManualCandidates,
  createNagraManualCandidate,
} = adminNagraCandidatesActions;

// ~~~ FINGERPRINTING ACTIONS ~~~
export const {
  initiateFetchFingerprintingConfigRequest,
  clearFingerprintingConfigRequest,
  updateFingerprintingConfigRequest,
} = fingerprintingActions;

// ~~~ ANALYTICS ACTIONS ~~~
export const {
  initiateLiveTrackerAnalyticsRequest,
  clearLiveTrackerAnalyticsRequest,
  initiateWatermarkDetectionsRequest,
  clearWatermarkDetectionsRequest,
} = analyticsActions;

// ~~~ CONTENT ID ACTIONS ~~~
// Assets
export const {
  initiateFetchAssetsRequest,
  clearContentIdAssetsRequest,
  initiateFetchAssetDetailsRequest,
  clearContentIdAssetDetailsRequest,
  updateContentIdAssetDetailsRequest,
  initiateFetchAssetMatchPolicyRequest,
  clearContentIdAssetMatchPolicyRequest,
  updateContentIdAssetMatchPolicyRequest,
  initiateCreateBulkAssetRequest,
  initiateFetchBulkAssetRequest,
  clearBulkAssetRequest,
  initiateFetchBulkAssetStatusRequest,
  clearBulkAssetStatusRequest,
} = contentIdAssetsActions;

// Claims
export const {
  initiateFetchClaimsRequest,
  initiateFetchAllClaimsRequest,
  clearContentIdClaimsRequest,
  initiateFetchClaimDetailsRequest,
  clearContentIdClaimDetailsRequest,
  initiateFetchClaimHistoryRequest,
  clearContentIdClaimHistoryRequest,
  initiateUpdateClaimsSettingsRequest,
  initiateMonetizationRequest,
} = contentIdClaimsActions;

// Manual claim requests (Content ID)
export const {
  initiateFetchManualClaimRequests,
  clearManualClaimRequests,
  initiateFetchManualClaimRequestDetail,
  clearManualClaimRequestDetail,
  initiateCreateManualClaimRequest,
} = contentIdManualClaimActions;

// Claim release requests (Content ID)
export const {
  initiateCreateClaimReleaseRequest,
  initiateFetchAssetClaimsCount,
  initiateReleaseAllAssetClaims,
  initiateRevertClaimReleaseRequest,
  initiateFetchActiveAssetReleaseRequest,
} = contentIdClaimReleaseActions;

// Allowlist
export const {
  initiateFetchAllowlistRequest,
  clearContentIdAllowlistRequest,
  addContentIdAllowlistChannelRequest,
  updateContentIdAllowlistChannelRequest,
  deleteContentIdAllowlistChannelRequest,
} = contentIdAllowlistActions;

// ~~~ CYCLOPS ACTIONS ~~~
// Organizations
export const {
  initiateCyclopsCompanyOrganizationsRequest,
  clearCyclopsCompanyOrganizationsRequest,
  submitNewCyclopsOrganizationRequest,
  setCyclopsActiveOrganizationRequest,
  clearCyclopsActiveOrganizationRequest,
  editCyclopsOrganizationRequest,
  deleteCyclopsOrganizationRequest,
  uploadCyclopsOrganizationVodRequest,
  updateCyclopsOrganizationCDNSettingsRequest,
  initiateCyclopsCDNConstantsRequest,
  clearCyclopsCDNConstantsRequest,
  initiateCyclopsConstantsConfigRequest,
  clearCyclopsConstantsConfigRequest,
} = organizationsActions;

// Livestreams
export const {
  initiateCyclopsLivestreamsRequest,
  clearCyclopsLivestreamsRequest,
  submitNewCyclopsLivestreamRequest,
  editCyclopsLivestreamRequest,
  deleteCyclopsLivestreamRequest,
  initiateCyclopsLivestreamDetailsRequest,
  clearCyclopsLivestreamDetailsRequest,
  startOrStopCyclopsLivestreamRequest,
  bypassPipelineCyclopsLivestreamRequest,
  initiateCyclopsWatermarksRequest,
  clearCyclopsWatermarksRequest,
  startStreamRippersCyclopsLivestreamRequest,
} = livestreamsActions;

// Piracy Streams
export const {
  initiateCyclopsPiracyStreamsRequest,
  clearCyclopsPiracyStreamsRequest,
  killCyclopsPiracyStreamRequest,
} = piracystreamsActions;

// Cyclops Analytics
export const {
  initiateCyclopsAnalyticsRequest,
  clearCyclopsAnalyticsRequest,
} = cyclopsAnalyticsActions;

// ~~~ OTHER ACTIONS ~~~
// Auth
export const {
  logInRequest: authLogInRequest,
  logOutRequest: authLogOutRequest,
  refreshRequest: authRefreshRequest,
  uploadCompanyLogoRequest: authUploadCompanyLogoRequest,
  sendPasswordResetInstructionsRequest,
  updatePasswordRequest,
  updateUserPreferenceRequest,
  fetchUsersRequest,
  clearUsersRequest,
  createNewUserRequest,
  deleteUserRequest,
  resendUserInviteRequest,
  fetchInviteTokenRequest,
  clearInviteTokenRequest,
  createInvitedUserRequest,
} = authActions;

// Payment
export const {
  initiateCreateSubscriptionRequest,
  clearVerticalTiersRequest,
  fetchVerticalTiersRequest,
  fetchCustomerSubscriptionRequest,
  clearCustomerSubscriptionRequest,
  fetchCancellationStatus,
  initiateUpdatePaymentMethodRequest,
  initiateUpdateSubscriptionRequest,
  initiateCreateCidOnboardingRequest,
  fetchOnboardingPricingRequest,
  clearOnboardingPricingRequest,
  initiateSubmitOnboardingRequest,
  clearSubmitOnboardingRequest,
  initiateProvisionOnboardingRequest,
  clearProvisionOnboardingRequest,
  fetchCustomerOnboardingData,
  clearCustomerOnboardingData,
  initiateCreateCancellationRequest,
  initiateWithdrawCancellationRequest,
  fetchPlanManagement,
  clearPlanManagement,
  clearPlanUpgradeResponse,
  initiateUpgradeSocialPlanRequest,
  fetchPrefillOnboardingDataRequest,
  clearPrefillOnboardingDataRequest,
  downloadOnboardingAgreementPreview,
  downloadPrefillAgreementPreview,
  fetchPayoutStatus,
  clearPayoutStatus,
  fetchPayoutAccount,
  clearPayoutAccount,
  fetchPayoutAccountSession,
  deletePayoutAccountRequest,
  updatePayoutBusinessInfo,
  fetchPayoutBusinessInfo,
} = paymentActions;

// Redirect
export const {
  initiateRedirectRequest,
  clearRedirectRequest,
} = redirectActions;

// Favicon
export const {
  setFaviconLoading,
  setFaviconReady,
  setFaviconDefault,
} = faviconActions;

// Notice
export const {
  closeNoticeRequest,
  arriveNotice,
  closeCustomNoticeRequest,
  arriveCustomNotice,
  startTourRequest,
  endTourRequest,
} = noticeActions;

// App config
export const { fetchAppConfigs } = appConfigActions;

// Abort Helper
export const { resetAbortController } = aborterHelper;

export const {
  fetchAdminDemoLinks,
  fetchAdminDemoLinkById,
  createAdminDemoLink,
  updateAdminDemoLink,
  deleteAdminDemoLink,
} = demoActions;

// Creator Referrals
export const {
  fetchCreatorReferrals,
  clearCreatorReferrals,
  fetchCreatorReferralInviteLink,
  clearCreatorReferralInviteLink,
  sendCreatorReferralInvite,
  fetchReferralInfoApi,
} = creatorReferralActions;

// Demo (user-facing)
export const {
  demoLogIn,
  fetchDemoLinkStatus,
  submitDemoInfo,
} = demoActions;
